import {
  DefaultError,
  QueryKey,
  UseQueryOptions,
  useQuery as useTanstackQuery,
} from '@tanstack/react-query'

export abstract class BaseQueryClass<
  Args extends unknown[],
  TQueryFnData = unknown,
  TError = DefaultError,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey,
> {
  abstract queryFn: (...args: Args) => Promise<TQueryFnData>
  abstract getQueryKey: (...args: Args) => TQueryKey
  protected options?: Omit<
    UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
    'queryKey' | 'queryFn'
  >

  public setQueryDataArgs = (args: Args, updater: (prevData: TData) => TData) =>
    [this.getQueryKey(...args), updater] as [
      TQueryKey,
      (prevData: TData) => TData,
    ]

  public useQueryBase = (args?: {
    queryFnArgs?: Args
    options?: Omit<
      UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
      'queryKey' | 'queryFn'
    >
  }) => {
    const { queryFnArgs, options } = args || {}
    const nonNullArgs = queryFnArgs || ([] as unknown as Args)
    return useTanstackQuery({
      queryKey: this.getQueryKey(...nonNullArgs),
      queryFn: () => this.queryFn(...nonNullArgs),
      ...this.options,
      ...options,
    })
  }
}
